import { render } from "./ArtistDisplay.vue?vue&type=template&id=ac7f4530&scoped=true"
import script from "./ArtistDisplay.vue?vue&type=script&lang=js"
export * from "./ArtistDisplay.vue?vue&type=script&lang=js"

import "./ArtistDisplay.vue?vue&type=style&index=0&id=ac7f4530&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac7f4530"]])

export default __exports__